import React from 'react'
import Layout from '../../components/layout/Layout'
import DeletedDriversTable from '../../elements/tables/driver/DeletedDriversTable'

export default function DeletedDrivers() {
  return (
    <div>
      <Layout>
        <DeletedDriversTable/>
      </Layout>
    </div>
  )
}
